import { ref, nextTick } from 'vue';
import { getWindowWidth, getWindowHeight } from '@/Utils/WindowUtility.js';
import { getHorizontalPosition, getVerticalPosition } from '@/Utils/BoundaryUtility.js';
import { setStyles } from '@/Utils/StylesUtility.js';

export const useBoundaryPosition = (initialVerticalPosition = null, initialPosition = null) => {
    const direction = ref(initialVerticalPosition);
    const anchor = ref(initialPosition);

    // Computes placement against the viewport, applies the resulting styles to the content
    // element and returns { direction, anchor }. The consumer decides whether to emit them.
    const updateBoundaryPosition = ({ trigger, content, position, verticalPosition }) => {
        if (!content || !trigger) {
            return null;
        }

        const triggerBounding = trigger.getBoundingClientRect();
        const contentBounding = content.getBoundingClientRect();
        const vertical = getVerticalPosition(getWindowHeight(), triggerBounding, contentBounding, verticalPosition);
        const horizontal = getHorizontalPosition(getWindowWidth(), triggerBounding, contentBounding, position);

        direction.value = vertical.direction;
        anchor.value = horizontal.anchor;

        nextTick(() => {
            setStyles(content, { ...vertical.style, ...horizontal.style });
        });

        return { direction: direction.value, anchor: anchor.value };
    };

    return {
        direction,
        anchor,
        updateBoundaryPosition,
    };
};
